import firebase from "firebase/compat/app";
import "firebase/compat/auth";

export const auth = firebase.initializeApp({
    apiKey: "AIzaSyC5m4XvoPm1M0ZJ5QESYt46TmzqvT2XrzY",
    authDomain: "chatup-c2945.firebaseapp.com",
    projectId: "chatup-c2945",
    storageBucket: "chatup-c2945.appspot.com",
    messagingSenderId: "22535454956",
    appId: "1:22535454956:web:3ea24ff464b7a2932ea5c9"
}).auth();
 


